import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";

    class ModelIdModel {
        modelId: string;

        constructor(modelId: string) {
            this.modelId = modelId;
        }
    }

    class ExportCommandLogModel {
        modelId: string;
        entryIds: string[];

        constructor(modelId: string, entryIds: string[]) {
            this.modelId = modelId;
            this.entryIds = entryIds;
        }
    }

    // Command log Api services
    export class ApiServices {

        /**
         * Clears log for a model
         * @param modelId
         * @param okCallback
         */
        deleteLog(modelId: string): Promise<any> {

            const request = {
                method: "post", data: new ModelIdModel(modelId)
            };

            return FetchWrapper.fetch("/api/1.0/commands/clearlog", request);
        }

        // For exporting a data set
        // searchTerm is a datatables search object
        exportLog(modelId: string, logIds: string[]): Promise<any> {

            //var data = JSON.parse(searchTerm);
            //data[0] = JSON.stringify(searchTerm);

            return FetchWrapper.fetch("/api/1.0/commands/export",
                {
                    method: "post",
                    body: JSON.stringify(new ExportCommandLogModel(modelId, logIds))
                });
            //global: false // Suppress default ajax complete handler

        }

        /**
         * Adds an annotation
         */
        addAnnotation(modelId: string, nodePathAndName: string, annotation: string): Promise<IBasicCommandResponse>  {
                const url = `/api/1.0/commands/annotate`;

                const payload = {
                    modelId: modelId,
                    nodePathAndName: nodePathAndName,
                    annotation: annotation
                };

                return FetchWrapper.sendCommandAndHandle(url, { method: "post", body: JSON.stringify(payload), }, false);
            }

        /**
         * Deletes an annotation
         */
        deleteAnnotation = (modelId: string, annotationId: string): Promise<IBasicCommandResponse> => {
            const url = `/api/1.0/commands/delete`;

            var payload = {
                modelId: modelId,
                annotationId: annotationId
            }

            return FetchWrapper.sendCommandAndHandle(url, { method: "post", body: JSON.stringify(payload) });
        }

        // Imports a command log
        importLog(modelId: string, formData: any): Promise<any> {

            const url = `/api/1.0/commands/import/${modelId}`;

            return $.ajax({
                url: url,
                type: "POST",
                data: formData,
                cache: false,
                contentType: false,
                processData: false
            });
        }

        /**
         * Gets the log for a model (using odata)
         */
        getLog = (modelId, queryString): Promise<any> => {
            var url = `/odata/${modelId}/CommandLog`;

            if (queryString)
                url = url + `?${queryString}`;

            return $.get(
                {
                    url: url,
                    //dataType: "jsonp"
                });

        }
    }



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.model-command-log-services.ts